export default {
    actualTime: "ORTEGX",
    appointments: "ORAEGX",
    assign: "ORASGX",
    billingInfo: "ORBIGX",
    customerPo: "ORPOGX",
    modifyOrderSegmentTask: "ORSVGX",
    nameOnOrder: "ORNOGX",
    newOrder: "ORXCGX",
    orderHeader: "ORHEGX",
    orderLine: "ORLEGX",
    overrideUnitPrice: "ORUPGX",
    overrideUnitCost: "ORUCGX",
    orderNotes: "ORNEGX",
    orderSegments: "OREEGX",
    partsCausingFailure: "ORPEGX",
    payments: "ORPYGX",
    serviceItems: "ORIEGX",
    shipTo: "ORSTGX",
    siteComments: "ORSCGX",
    siteDetails: "ORSDGX",
    siteInfo: "ORSIGX",
    viewAllAccessibleRegions: "ORARGX",
    voidInvoice: "ORVIGX",
    actionButtons: {
        approveActualTime: "ATAPGX",
        billing: "ORBLGX",
        complete: "ORCOGX",
        reopenInspection: "ORRIGX",
        reopenOrder: "ORROGX",
        shipping: "ORSHGX"
    },
    travelLogs: "ORTLGX"
};
